"use strict";
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const axios_1 = tslib_1.__importDefault(require("axios"));
const typeorm_1 = require("typeorm");
const constants_1 = require("../../../../../../apps/services/service-lib/src/lib/constants");
const constants_2 = require("../../../../../../libs/service-lib/src/lib/constants");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const lookup_validation_1 = require("../../../../service-lib/src/lib/utils/lookup-validation");
const masters_validation_1 = require("../../../../service-lib/src/lib/utils/masters-validation");
const look_up_repository_1 = require("../look-up/look-up.repository");
const company_repository_1 = require("./company.repository");
const helper_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/helper.utils");
const address_service_1 = require("../address/address.service");
const company_address_entity_1 = require("../../../../service-lib/src/lib/entities/company.address.entity");
const notification_utils_1 = require("../../../../service-lib/src/lib/utils/notification.utils");
const environment_1 = require("../../../../service-lib/src/lib/environment");
let CompanyService = class CompanyService {
    constructor(dataSource, companyRepository, lookUpRepository, lookUpValidation, masterValidation, addressService, notificationUtils) {
        this.dataSource = dataSource;
        this.companyRepository = companyRepository;
        this.lookUpRepository = lookUpRepository;
        this.lookUpValidation = lookUpValidation;
        this.masterValidation = masterValidation;
        this.addressService = addressService;
        this.notificationUtils = notificationUtils;
    }
    async createCompany(companyDto, companyDetailsDto, userId) {
        try {
            const response = await this.dataSource.transaction(async (entityManager) => {
                // Check for duplicate company name (case-insensitive)
                const existingCompany = await this.companyRepository.findCompanyByName(companyDto.companyName);
                if (existingCompany) {
                    throw new Error(`A company with the name ${companyDto.companyName} already exists.`);
                }
                await this.lookUpValidation.validateDynamicLookupValues(companyDto, constants_2.LOOK_UP_DATA);
                await this.masterValidation.validateMasterIds(companyDto, constants_2.MASTER_DATA);
                // Create the company
                const companyData = companyDto;
                const companyStatus = await this.lookUpRepository.findByLookUpKey(constants_1.COMPANY_STATUS_KEY.ACTIVE);
                if (!companyStatus || !companyStatus[0].id) {
                    throw new common_1.NotFoundException(`Company status with key ${constants_1.COMPANY_STATUS_KEY.ACTIVE} not found`);
                }
                const company = await this.companyRepository.createCompany(entityManager, {
                    ...companyData,
                    statusLid: companyDto.statusLid ?? companyStatus[0].id,
                    annualPremium: Number(companyData.annualPremium ?? 0),
                });
                debugger;
                //check the priority company or not for sending the in app notifications
                const isPriorityCompany = await this.companyRepository.isPriorityCompany(entityManager, company.priorityLid);
                if (isPriorityCompany) {
                    const url = `${environment_1.ENV.CLIENT_SERVER_URL}companies/${company.id}`;
                    await this.sendNotification(constants_1.NOTIFICATION_EVENT_TYPES.PRIORITY_COMPANY_CREATION, url, companyDto?.createdBy || userId, true, false);
                }
                if (companyDto.annualPremium &&
                    companyDto.annualPremium >
                        constants_1.COMPANY_SUM_INSURED_NOTIFICATION_THRESHOLD) {
                    const url = `${environment_1.ENV.CLIENT_SERVER_URL}companies/${company.id}`;
                    const userOrganisationIds = await this.companyRepository.getEntityTableMapIds(constants_2.TABLE_NAMES.USER, constants_2.ORGANISATION_ID, { userId: userId });
                    const employeeIds = await this.companyRepository.getEntityTableMapIds(constants_2.TABLE_NAMES.EMPLOYEE, constants_2.EMPLOYEE_USER_ID, { organisationId: userOrganisationIds[0] });
                    for (let employeeId of employeeIds) {
                        await this.sendNotification(constants_1.NOTIFICATION_EVENT_TYPES.HIGH_PREMIUM_COMPANY_CREATION, url, employeeId, true, true);
                    }
                }
                // Create GST details
                if (companyDto.gstDetails && companyDto.gstDetails.length > 0) {
                    for (const gst of companyDto.gstDetails) {
                        await this.companyRepository.createGstDetail(entityManager, {
                            ...gst,
                            company,
                        });
                    }
                }
                // Create multiple addresses if provided
                if (companyData.addresses && companyData.addresses.length) {
                    for (const addressDto of companyData.addresses) {
                        const savedAddress = await this.addressService.addAddress(addressDto, company.createdBy);
                        const companyAddress = entityManager.create(company_address_entity_1.CompanyAddress, {
                            company: { id: company.id },
                            address: { id: savedAddress.id },
                            isPrimary: false, // Optional: Set this to true if needed
                        });
                        await entityManager.save(companyAddress);
                    }
                }
                else {
                    throw new Error(messages_1.errorMessages.companyAddressRequired);
                }
                // Create company details
                if (companyDetailsDto) {
                    companyDetailsDto.createdBy = company.createdBy;
                    companyDetailsDto.updatedBy = company.updatedBy;
                    await this.companyRepository.createCompanyDetails(entityManager, {
                        ...companyDetailsDto,
                        company,
                    });
                }
                const groupCompanyLookup = await this.lookUpRepository.getLookUpById(companyData.groupCompanyLid);
                const isGroupCompany = groupCompanyLookup?.data?.lookUpName === constants_1.GROUP_COMPANY.Name &&
                    groupCompanyLookup?.data?.lookUpValueKey !== constants_1.GROUP_COMPANY.keyValue;
                if (companyDto.groupCompanyMap && isGroupCompany) {
                    await this.companyRepository.createGroupCompanyMap(entityManager, {
                        ...companyDto.groupCompanyMap,
                        company,
                    });
                }
                else if (!companyDto.groupCompanyMap && isGroupCompany) {
                    throw new common_1.NotFoundException("Group company map not found");
                }
                // Create company document mappings
                if (companyDto.companyDocMaps &&
                    companyDto.companyDocMaps?.length > 0) {
                    for (const companyDocMap of companyDto.companyDocMaps) {
                        if (!companyDocMap.documentId) {
                            throw new Error(messages_1.errorMessages.companyDocumentError);
                        }
                        await this.companyRepository.createCompanyDocMap(entityManager, {
                            ...companyDocMap,
                            company,
                        });
                    }
                }
                delete company.createdAt;
                delete company.updatedAt;
                delete company.deletedAt;
                delete company.createdBy;
                delete company.updatedBy;
                return { id: company.id };
            });
            if (response.id !== undefined && response.id !== null) {
                return await this.companyRepository.getCompanyById(response.id);
            }
        }
        catch (error) {
            if (error.message.includes("Duplicate entry")) {
                throw new Error(error.message); // Propagate the duplicate entry error
            }
            throw error; // Re-throw other errors
        }
    }
    // Retrieves a company by its unique identifier.
    async getCompanyById(id, userId) {
        try {
            const company = await this.companyRepository.getCompanyById(Number(id), userId);
            if (!company) {
                throw new common_1.NotFoundException(messages_1.errorMessages.companyNotFound);
            }
            return company;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error.message);
        }
    }
    // Deletes a company by its unique identifier.
    async deleteCompanyById(id) {
        try {
            // Check if the company exists
            const company = await this.companyRepository.getCompanyById(Number(id));
            if (!company) {
                throw new Error(`Company with ID ${id} does not exist`);
            }
            // Proceed with the soft delete
            const deleteResult = await this.companyRepository.deleteByCompanyId(id);
            return (deleteResult.affected ?? 0) > 0;
        }
        catch (error) {
            throw new Error(error.message || "Failed to delete company by ID");
        }
    }
    // Retrieves a paginated list of companies based on the provided parameters.
    async listCompanies(page, limit, search, sort, userId, searchBy) {
        try {
            const searchParams = (0, helper_utils_1.mapSearchParams)(search);
            const sortParams = (0, helper_utils_1.mapSortParams)(sort);
            sortParams?.forEach((param) => {
                if (param.field === constants_1.PRIORITY_LOOK_UP.value) {
                    param.field = constants_1.PRIORITY_LOOK_UP.order;
                }
            });
            if (sortParams) {
                const companySortOrderSearch = sortParams.find((item) => item.field === constants_1.sortRealtionsMapping.PARENT_COMPANY_NAME_SORT_KEY);
                if (companySortOrderSearch) {
                    companySortOrderSearch.field =
                        constants_1.sortRealtionsMapping.PARENT_COMPANY_SORT;
                }
            }
            const companies = await this.companyRepository.findAllCompanyList(page, limit, searchParams, sortParams, userId, searchBy);
            companies.data = companies.data.map((company) => {
                const contacts = company?.companyContactMaps
                    ?.map((map) => map.contact)
                    .filter(Boolean);
                return {
                    ...company,
                    contacts,
                };
            });
            return companies;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error; // Re-throw NotFoundException to be handled by the controller
            }
            throw new Error(messages_1.errorMessages.companyListFailed);
        }
    }
    // Updates a company's details by its ID.
    async updateCompany(companyId, companyDto, companyDetailsDto) {
        try {
            const response = await this.dataSource.transaction(async (entityManager) => {
                const response = {};
                const userId = companyDto.updatedBy;
                if (companyDto) {
                    await this.lookUpValidation.validateDynamicLookupValues(companyDto, constants_2.LOOK_UP_DATA);
                    await this.masterValidation.validateMasterIds(companyDto, constants_2.MASTER_DATA);
                    const invalidFields = Object.keys(companyDto).filter((key) => Array.isArray(constants_2.companyNonEditableFields) &&
                        constants_2.companyNonEditableFields.includes(key));
                    if (invalidFields.length > 0) {
                        throw new common_1.ForbiddenException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, `The following fields are non-editable: ${invalidFields.join(", ")}`));
                    }
                    const updatedCompany = await this.companyRepository.updateCompany(entityManager, companyId, companyDto);
                    if (!updatedCompany) {
                        throw new common_1.NotFoundException(messages_1.errorMessages.companyNotFound);
                    }
                    else {
                        const groupCompanyLookup = await this.lookUpRepository.getLookUpById(updatedCompany.groupCompanyLid);
                        if (groupCompanyLookup?.data?.lookUpName === constants_1.GROUP_COMPANY.Name &&
                            groupCompanyLookup?.data?.lookUpValueKey ===
                                constants_1.GROUP_COMPANY.keyValue) {
                            await this.companyRepository.deleteGroupCompanyMap(entityManager, Number(companyId));
                            companyDto.groupCompanyMap = undefined;
                        }
                        delete updatedCompany.createdAt;
                        delete updatedCompany.updatedAt;
                        delete updatedCompany.createdBy;
                        delete updatedCompany.updatedBy;
                        delete updatedCompany.deletedAt;
                    }
                    response.company = updatedCompany;
                }
                if (companyDto.gstDetails) {
                    const existingStateGstIds = await this.companyRepository.getEntityTableMapIds(constants_1.COMPANY_MAP_TABLE_DELETE_FIELDS.STATE_GST_DETAILS, constants_1.COMPANY_MAP_TABLE_DELETE_FIELDS.ID, { companyId: companyId });
                    if (companyDto.gstDetails.length > 0) {
                        const updatedGstDetails = [];
                        for (const gst of companyDto.gstDetails) {
                            if (gst.id) {
                                const index = existingStateGstIds.indexOf(gst.id);
                                if (index !== -1) {
                                    existingStateGstIds.splice(index, 1);
                                }
                                // Ensure the GST detail belongs to the correct company
                                gst.companyId = companyId; // Ensure the company ID is set
                                // Update existing GST detail
                                const updatedGst = await this.companyRepository.updateGstDetail(entityManager, gst);
                                delete updatedGst.createdAt;
                                delete updatedGst.updatedAt;
                                delete updatedGst.deletedAt;
                                updatedGstDetails.push(updatedGst);
                            }
                            else {
                                gst.companyId = companyId;
                                // Create new GST detail
                                const createdGst = await this.companyRepository.createGstDetail(entityManager, gst);
                                delete createdGst.createdAt;
                                delete createdGst.updatedAt;
                                delete createdGst.deletedAt;
                                updatedGstDetails.push(createdGst);
                            }
                        }
                        response.gstDetails = updatedGstDetails;
                    }
                    await this.companyRepository.deleteEntityTableMapIds(constants_1.COMPANY_MAP_TABLE_DELETE_FIELDS.STATE_GST_DETAILS, existingStateGstIds, constants_1.COMPANY_MAP_TABLE_DELETE_FIELDS.ID, constants_2.MAPPED_DATA_DELETION.SOFT_DELETE);
                }
                if (companyDto.addresses) {
                    const existingCompanyAddressIds = await this.companyRepository.getEntityTableMapIds(constants_1.COMPANY_MAP_TABLE_DELETE_FIELDS.COMPANY_ADDRESS, constants_1.COMPANY_MAP_TABLE_DELETE_FIELDS.ADDRESS_ID, { company: { id: companyId } });
                    if (companyDto.addresses.length > 0) {
                        const updateAddresses = [];
                        const createAddresses = [];
                        const addressIdsToUpdate = [];
                        for (const address of companyDto.addresses) {
                            const { id: addressId, ...addressData } = address;
                            if (addressId) {
                                const index = existingCompanyAddressIds.indexOf(addressId);
                                if (index !== -1) {
                                    existingCompanyAddressIds.splice(index, 1);
                                }
                                // Collect update address data
                                addressIdsToUpdate.push(addressId);
                                updateAddresses.push({ addressId, addressData });
                            }
                            else {
                                // Collect create address data
                                addressData.createdBy = userId;
                                addressData.updatedBy = userId;
                                createAddresses.push(addressData);
                            }
                        }
                        // Retrieve all existing address IDs of the company
                        const existingAddresses = await entityManager.find(company_address_entity_1.CompanyAddress, {
                            where: { company: { id: Number(companyId) } },
                            relations: ["address"],
                        });
                        const existingAddressIds = existingAddresses.map((companyAddress) => companyAddress.address.id);
                        // Validate received address IDs against existing address IDs
                        const invalidIds = addressIdsToUpdate?.filter((id) => !existingAddressIds.includes(id));
                        if (invalidIds.length > 0) {
                            throw new common_1.NotFoundException(`Address with ID(s) ${invalidIds.join(", ")} not found for company ID ${companyId}`);
                        }
                        if (updateAddresses.length > 0) {
                            await Promise.all(updateAddresses.map(({ addressId, addressData }) => this.addressService.updateAddressById(addressId, addressData, userId)));
                        }
                        if (createAddresses.length > 0) {
                            const savedAddresses = await Promise.all(createAddresses.map((addressData) => this.addressService.addAddress(addressData, userId)));
                            const companyAddresses = savedAddresses.map((savedAddress) => entityManager.create(company_address_entity_1.CompanyAddress, {
                                company: { id: companyId },
                                address: { id: savedAddress.id },
                                isPrimary: false, // Optional: Set this to true if needed
                            }));
                            await entityManager.save(company_address_entity_1.CompanyAddress, companyAddresses);
                        }
                    }
                    await this.companyRepository.deleteEntityTableMapIds(constants_1.COMPANY_MAP_TABLE_DELETE_FIELDS.COMPANY_ADDRESS, existingCompanyAddressIds, constants_1.COMPANY_MAP_TABLE_DELETE_FIELDS.ADDRESS_ID, constants_2.MAPPED_DATA_DELETION.MAP_REMOVED);
                }
                if (companyDetailsDto) {
                    const updatedCompanyDetails = await this.companyRepository.updateCompanyDetails(entityManager, companyId, companyDetailsDto);
                    if (updatedCompanyDetails) {
                        delete updatedCompanyDetails.createdAt;
                        delete updatedCompanyDetails.updatedAt;
                        delete updatedCompanyDetails.createdBy;
                        delete updatedCompanyDetails.updatedBy;
                        delete updatedCompanyDetails.deletedAt;
                        response.companyDetails = updatedCompanyDetails;
                    }
                }
                if (companyDto.groupCompanyMap) {
                    companyDto.groupCompanyMap.companyId = Number(companyId);
                    const updatedGroupCompanyMap = await this.companyRepository.createOrUpdateGroupCompanyMap(entityManager, companyDto.groupCompanyMap);
                    response.groupCompanyMap = updatedGroupCompanyMap;
                }
                // Create company document mappings
                if (companyDto.companyDocMaps &&
                    companyDto.companyDocMaps.length > 0) {
                    const updatedCompanyDocMaps = [];
                    for (const companyDocMap of companyDto.companyDocMaps) {
                        companyDocMap.companyId = Number(companyId);
                        const updatedCompanyDocMap = await this.companyRepository.createOrUpdateCompanyDocMap(entityManager, companyDocMap);
                        updatedCompanyDocMaps.push(updatedCompanyDocMap);
                    }
                    response.companyDocMaps = updatedCompanyDocMaps;
                }
                return { id: Number(companyId) };
            });
            if (response.id !== undefined && response.id !== null) {
                return await this.companyRepository.getCompanyById(response.id);
            }
        }
        catch (error) {
            if (error.message.includes("Duplicate entry")) {
                throw new Error(error.message); // Propagate the duplicate entry error
            }
            throw error; // Re-throw the error to be handled by the controller
        }
    }
    async getCompanyList(page, limit, search, userId, entityIds) {
        try {
            // Check if the user has permission to access the company list
            return await this.companyRepository.CompanyList(page, limit, search, userId, entityIds);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error; // Re-throw NotFoundException to be handled by the controller
            }
            throw new Error(messages_1.errorMessages.companyListFailed);
        }
    }
    async getCompanyBasicDetails(id, userId, contactId) {
        try {
            const fields = ["id", "companyName", "displayName"];
            const relations = [
                "companyAddresses.address",
                "companyContactMaps.contact",
            ];
            const whereCondition = {
                id: id,
            };
            const companyDetails = await this.companyRepository.getCompanyListData(fields, relations, whereCondition, contactId);
            if (!companyDetails) {
                throw new common_1.NotFoundException(messages_1.errorMessages.companyNotFound);
            }
            return companyDetails;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error.message);
        }
    }
    async getCompanies(page, limit, userId, search) {
        try {
            const companies = await this.companyRepository.getCompanies(page, limit, userId, search);
            return companies;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new Error(messages_1.errorMessages.companyListFailed);
        }
    }
    async getCountryId(userId) {
        try {
            const countryId = await this.dataSource.manager.transaction(async (entityManager) => {
                return await this.companyRepository.getCountryId(entityManager, userId);
            });
            return countryId;
        }
        catch (error) {
            throw new common_1.BadRequestException(error.message);
        }
    }
    async getCurrencyId(countryId) {
        try {
            const currencyId = await this.dataSource.manager.transaction(async (entityManager) => {
                return await this.companyRepository.getCurrencyId(entityManager, countryId);
            });
            return currencyId;
        }
        catch (error) {
            throw new common_1.BadRequestException(error.message);
        }
    }
    async getGroupCompanies(page, limit, search, userId) {
        try {
            // Check if the user has permission to access the company list
            const companies = await this.dataSource.manager.transaction(async (entityManager) => {
                return await this.companyRepository.getGroupCompanies(entityManager, page, limit, search, userId);
            });
            return companies;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error; // Re-throw NotFoundException to be handled by the controller
            }
            throw new Error(messages_1.errorMessages.groupCompanyListNotFound);
        }
    }
    async sendNotification(eventType, url, notifyUserId, sendInAppNotification, sendEmailNotification) {
        try {
            const userEmail = await this.companyRepository.getEntityTableMapIds(constants_2.TABLE_NAMES.USER, constants_2.USER_EMAIL, { userId: notifyUserId });
            if (!userEmail || userEmail.length === 0) {
                throw new common_1.NotFoundException(`Email details for the user with ID ${notifyUserId} not found`);
            }
            const eventDetails = await this.notificationUtils.getNotificationDetailsByEvent(eventType);
            const parameters = { [`${eventDetails[0].parameterKey}`]: url };
            if (sendInAppNotification) {
                await axios_1.default.post(`${environment_1.ENV.URL_NOTIFICATION_SERVICE}/notifications`, {
                    eventType: eventType,
                    emailId: userEmail,
                    channel: constants_1.NOTIFICATION_IN_APP,
                    parameters: parameters,
                    userId: [notifyUserId],
                });
            }
            if (sendEmailNotification) {
                await axios_1.default.post(`${environment_1.ENV.URL_NOTIFICATION_SERVICE}/notifications`, {
                    eventType: eventType,
                    emailId: userEmail,
                    channel: constants_1.NOTIFICATION_EMAIL,
                    parameters: parameters,
                    userId: [notifyUserId],
                });
            }
        }
        catch (error) {
            console.log(error);
        }
    }
};
exports.CompanyService = CompanyService;
exports.CompanyService = CompanyService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_1.DataSource !== "undefined" && typeorm_1.DataSource) === "function" ? _a : Object, typeof (_b = typeof company_repository_1.CompanyRepository !== "undefined" && company_repository_1.CompanyRepository) === "function" ? _b : Object, typeof (_c = typeof look_up_repository_1.LookUpRepository !== "undefined" && look_up_repository_1.LookUpRepository) === "function" ? _c : Object, typeof (_d = typeof lookup_validation_1.LookUpValidationService !== "undefined" && lookup_validation_1.LookUpValidationService) === "function" ? _d : Object, typeof (_e = typeof masters_validation_1.MasterValidationService !== "undefined" && masters_validation_1.MasterValidationService) === "function" ? _e : Object, typeof (_f = typeof address_service_1.AddressService !== "undefined" && address_service_1.AddressService) === "function" ? _f : Object, typeof (_g = typeof notification_utils_1.NotificationUtils !== "undefined" && notification_utils_1.NotificationUtils) === "function" ? _g : Object])
], CompanyService);
